(function () {
  'use strict';

  angular.module('app').component('productTaxesTable', productTaxesTable());

  function productTaxesTable() {
    return {
      bindings: {
        product: '<',
        currency: '<',
      },
      controller: function () {},
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/taxes/components/product-taxes-table/product-taxes-table.component.html',
    };
  }
})();
